import React, { MouseEvent, useState } from 'react';

import t from '../../../labels/labelling-utils';
import { makeClassNames } from '../../../utils/styles';
import DropdownMenu from '../dropdown-menu/dropdown-menu';

import './additive-filter.scss';

export interface IAdditiveFilterSecondaryDropdown {
  label: string;
}

export interface IAdditiveFilterModel {
  secondaryDropdownModel?: IAdditiveFilterSecondaryDropdown[] | null;
  name: string;
}
export interface IAdditiveFilter {
  filterModel: IAdditiveFilterModel[];
  onChange: (competitionIndex: number, dateIndex: number) => any;
  primaryDropdownTitle?: string;
  secondaryDropdownTitle?: string;
  ariaLabel?: string;
}

/* istanbul ignore next: "else path not taken" bug */
const mapPrimaryToDropdownModel = (filterModel: IAdditiveFilterModel[], selectedIndex = 0) =>
  filterModel.map((item: IAdditiveFilterModel, index: number) => {
    return {
      label: item.name,
      isSelected: selectedIndex === index,
    };
  });

/* istanbul ignore next: "else path not taken" bug */
const mapSecondaryToDropdownModel = (secondaryDropdownModel: IAdditiveFilterSecondaryDropdown[], selectedIndex = 0) =>
  secondaryDropdownModel.map((date: IAdditiveFilterSecondaryDropdown, index: number) => {
    return {
      label: date.label,
      isSelected: selectedIndex === index,
    };
  });

const classNames = () =>
  makeClassNames({
    additiveFilter: 'additive-filter',
    spacer: 'additive-filter__spacer',
  });

const AdditiveFilter = ({
  filterModel,
  /* istanbul ignore next: default value on mandatory field */ onChange = () => {},
  primaryDropdownTitle,
  secondaryDropdownTitle,
  ariaLabel,
}: IAdditiveFilter) => {
  const cn = classNames();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedSecondaryIndex, setSelectedSecondaryIndex] = useState(0);

  const onPrimaryDropdownChange = (event: MouseEvent, index: number) => {
    if (selectedIndex !== index) {
      setSelectedIndex(index);
      setSelectedSecondaryIndex(0);
      onChange(index, 0);
    }
  };

  const onSecondaryDropdownChange = (event: MouseEvent, index: number) => {
    /* istanbul ignore else */ if (index !== selectedSecondaryIndex) {
      setSelectedSecondaryIndex(index);
      onChange(selectedIndex, index);
    }
  };

  return (
    <div className={cn.additiveFilter} role="combobox" aria-haspopup="listbox" aria-label={ariaLabel}>
      <DropdownMenu
        title={primaryDropdownTitle}
        text={
          /* istanbul ignore next: optional chaining */ filterModel[selectedIndex]?.name ||
          /* istanbul ignore next: prop is mandatory */ t('additive.filter.fallback.title')
        }
        onClick={onPrimaryDropdownChange}
        links={mapPrimaryToDropdownModel(filterModel)}
        showSelected
        menuSize="medium"
      />
      <div className={cn.spacer} />
      {filterModel[0]?.secondaryDropdownModel?.length ? (
        <DropdownMenu
          title={secondaryDropdownTitle}
          text={
            /* istanbul ignore next: optional chaining */ filterModel[selectedIndex]?.secondaryDropdownModel?.[
              selectedSecondaryIndex
            ]?.label || /* istanbul ignore next: prop is mandatory */ t('additive.filter.fallback.date.title')
          }
          onClick={onSecondaryDropdownChange}
          links={mapSecondaryToDropdownModel(
            /* istanbul ignore next: optional chaining */ filterModel[selectedIndex]?.secondaryDropdownModel || []
          )}
          showSelected
          menuSize="medium"
        />
      ) : null}
    </div>
  );
};

export default AdditiveFilter;
